"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDefaultErrorBoundaryOptions = exports.setDefaultErrorBoundaryFallback = exports.ErrorBoundary = void 0;
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var setupErrorHandler_1 = require("./setupErrorHandler");
var DefaultFallback = function (props) {
    var error = props.error;
    return react_1.default.createElement("div", { style: { color: 'red' } }, error.message);
};
var OPTIONS_DEFAULTS = {
    logCaughtErrors: true,
    allowDevErrorOverlay: false,
};
var logCaughtError = function (error) {
    if (process.env.NODE_ENV === 'development') {
        console.error('Following error has been caught by <ErrorBoundary> component\n\n', error);
    }
};
var ErrorBoundary = function (props) {
    var children = props.children, _a = props.FallbackComponent, FallbackComponent = _a === void 0 ? DefaultFallback : _a, fallbackRender = props.fallbackRender, fallback = props.fallback, onError = props.onError, _b = props.allowDevErrorOverlay, allowDevErrorOverlay = _b === void 0 ? OPTIONS_DEFAULTS.allowDevErrorOverlay : _b, _c = props.logCaughtErrors, logCaughtErrors = _c === void 0 ? OPTIONS_DEFAULTS.logCaughtErrors : _c, rest = __rest(props, ["children", "FallbackComponent", "fallbackRender", "fallback", "onError", "allowDevErrorOverlay", "logCaughtErrors"]);
    var handleError = (0, react_1.useCallback)(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var error = args[0];
        if (!allowDevErrorOverlay) {
            (0, setupErrorHandler_1.suppressCaughtOverlayError)(error);
            if (logCaughtErrors)
                logCaughtError(error);
        }
        onError === null || onError === void 0 ? void 0 : onError.apply(void 0, args);
    }, [onError, allowDevErrorOverlay, logCaughtErrors]);
    if (fallback) {
        return (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, __assign({ fallback: fallback, onError: handleError }, rest), children));
    }
    if (fallbackRender) {
        return (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, __assign({ fallbackRender: fallbackRender, onError: handleError }, rest), children));
    }
    if (FallbackComponent) {
        return (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, __assign({ FallbackComponent: FallbackComponent, onError: handleError }, rest), children));
    }
    return null;
};
exports.ErrorBoundary = ErrorBoundary;
function setDefaultErrorBoundaryFallback(component) {
    DefaultFallback = component;
}
exports.setDefaultErrorBoundaryFallback = setDefaultErrorBoundaryFallback;
function setDefaultErrorBoundaryOptions(defaults) {
    Object.assign(OPTIONS_DEFAULTS, defaults);
}
exports.setDefaultErrorBoundaryOptions = setDefaultErrorBoundaryOptions;
